import styled, { css } from 'styled-components';
import { lighten } from '@jiaminghi/color';
import Button from '../../../../components/Common/Button';
import InfoSvg from './assets/info.svg';

export const StyledButton = styled(Button)`${(props) => {
  const hoverBC = lighten(props.styled.backgroundColor, 10);

  return css`
    && {
        display: flex;
        width: 30px;
        height: 30px;
        align-items: center;
        justify-content: center;
        margin: 0;
        padding: 0;
        border: 1px solid ${props.styled.backgroundColor};
        background-color: transparent;
        color: ${props.styled.color};
        flex-shrink: 0;

        &:hover:not(:disabled) {
          background-color: ${hoverBC};
          box-shadow: none;
          color: ${props.styled.color};
        }

        &:active:not(:disabled) {
          background-color: ${props.styled.backgroundColor};
        }

        &:disabled {
          opacity: 0.3;
        }

        &:focus {
          background-image: none;
        }
      }
    `;
}}`;

export const StyledIcon = styled(InfoSvg)`
  width: 12px;
  height: 12px;
`;
